import { IFightNft } from './FightNft';

export enum BattleStages {
  INIT,
  CONNECTING,
  WAITING,
  ACTION,
  ERROR
}

export type BattleStageAfterConnect =
  | BattleStages.WAITING
  | BattleStages.ACTION;

type StageInit = {
  marker: BattleStages.INIT;
};

type StageConnecting = {
  marker: BattleStages.CONNECTING;
  nft: IFightNft;
  bet: number;
  nextStage: BattleStageAfterConnect;
};

type StageWaiting = {
  marker: BattleStages.WAITING;
  nft: IFightNft;
  bet: number;
};

type StageFight = {
  marker: BattleStages.ACTION;
  nft: IFightNft;
  bet: number;
};

type StageError = {
  marker: BattleStages.ERROR;
};

export type BattleStage =
  | StageInit
  | StageConnecting
  | StageWaiting
  | StageFight
  | StageError;
